<template>
  <custom-dialog
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    width="1200px"
    class="resource-item-select-device-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table
          ref="table"
          height="400px"
          :data="tableList"
          tableCode="resource_protocol_detail"
          type="checkbox"
          v-model="selectedData"
          :filterArr="['action']"
        ></custom-table>
      </div>
      <!-- 分页 -->
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{$t('Common.com_cancel')}}</el-button>
      <el-button
        :disabled="!selectedData.length"
        type="primary"
        @click="onConfirm"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {},
  data() {
    return {
      tableCode: 'case_order_select_device',
      formSearch: {
        search: '',
        protocolCode: '',
        pageSize: 50,
        pageNum: 1,
      },
      selectedData: [],
      tableList: [],
      totalRows: 0,
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onConfirm() {
      this.closeDialog();
      this.$emit('confirm', this.selectedData);
    },
    closeDialog() {
      this.visible = false;
    },
    getTableList() {
      this.formSearch.protocolCode = this.model.protocolCode;
      this.$getJSON(apis.ProductProductVersionSelect, this.formSearch).then((res) => {
        this.tableList = res.data;
      });
    },
    onSearch() {
      this.getTableList();
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;

      this.getTableList();
    },
  },
  created() { },
  mounted() {
    this.getTableList();
  },
};
</script>

<style lang="scss" scoped>
.resource-item-select-device-dialog {
  // /deep/ .el-table__fixed-header-wrapper .el-checkbox {
  //   //找到表头那一行，然后把里面的复选框隐藏掉
  //   display: none;
  // }
}
</style>
